module.exports = __webpack_public_path__ + "static/media/kids-baking-course-bg.bb57aa9b.webp";